var _style, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOutlineGreenCheckmarkIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.outline-green-checkmark-icon-st0{fill:#67B346;}\n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "outline-green-checkmark-icon-st0",
    d: "M25,7C15.1,7,7,15.1,7,25s8.1,18,18,18s18-8.1,18-18S34.9,7,25,7z M25,41c-8.8,0-16-7.2-16-16S16.2,9,25,9 s16,7.2,16,16S33.8,41,25,41z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "outline-green-checkmark-icon-st0",
    points: "33,18.5 23.6,30.7 16.6,25.4 15.4,27 22.4,32.3 22.4,32.3 23.9,33.5 34.6,19.7  "
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlineGreenCheckmarkIcon);
export default __webpack_public_path__ + "static/media/outline_green_checkmark_icon.4fce4bfe236010af21614ade6a34322f.svg";
export { ForwardRef as ReactComponent };